var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_invoice_act",
          attrs: {
            id: "modal-invoice-act",
            title: "Акт",
            "content-class": "modal-fullscreen",
            "body-class": "modal-body-fullscreen",
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            scrollable: ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "custom-btn-secondary mr-2",
                      on: {
                        click: function($event) {
                          return _vm.hideModal()
                        }
                      }
                    },
                    [_vm._v("\n        Отменить\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "custom-btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.onOK()
                        }
                      }
                    },
                    [_vm._v("\n        Сохранить\n      ")]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "b-form",
            [
              _c(
                "b-row",
                { attrs: { "cols-lg": "4", "cols-md": "2", cols: "1" } },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Акт №" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "input_numb",
                              size: "sm",
                              autocomplete: "off"
                            },
                            model: {
                              value: _vm.newItem.numb,
                              callback: function($$v) {
                                _vm.$set(_vm.newItem, "numb", _vm._n($$v))
                              },
                              expression: "newItem.numb"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Дата" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "input-date",
                              size: "sm",
                              type: "date"
                            },
                            model: {
                              value: _vm.newItem.date,
                              callback: function($$v) {
                                _vm.$set(_vm.newItem, "date", $$v)
                              },
                              expression: "newItem.date"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Договор (№ и Дата)" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "input-contract",
                              size: "sm",
                              autocomplete: "off"
                            },
                            model: {
                              value: _vm.newItem.contract,
                              callback: function($$v) {
                                _vm.$set(_vm.newItem, "contract", $$v)
                              },
                              expression: "newItem.contract"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Место составления (Город)" } },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "input-town",
                              size: "sm",
                              autocomplete: "off"
                            },
                            model: {
                              value: _vm.newItem.town,
                              callback: function($$v) {
                                _vm.$set(_vm.newItem, "town", $$v)
                              },
                              expression: "newItem.town"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-card", { staticClass: "custom-card" }, [
            _c(
              "div",
              { staticClass: "d-flex align-items-center w-100" },
              [
                _c("h5", [_vm._v("Работы")]),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: { variant: "link" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.onAddWork()
                      }
                    }
                  },
                  [
                    _c("v-icon", {
                      staticClass: "mr-1",
                      attrs: { name: "buttons/plus", size: 10 }
                    }),
                    _vm._v("\n          Добавить\n        ")
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "page-body" }, [
              _c(
                "div",
                { staticClass: "page-table-container" },
                [
                  _c("b-table", {
                    ref: "invoice-works",
                    staticClass: "custom-table mb-0",
                    attrs: {
                      id: "invoice-works",
                      selectable: "",
                      "select-mode": "single",
                      responsive: "",
                      "show-empty": "",
                      "empty-text": _vm.$t("message.common.emptyTable"),
                      items: _vm.newItem.works,
                      fields: _vm.worksFields,
                      "no-provider-filtering": "",
                      "no-provider-paging": "",
                      "no-provider-sorting": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "table-busy",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              { staticClass: "text-center text-success my-2" },
                              [
                                _c("b-spinner", {
                                  staticClass: "align-middle"
                                }),
                                _vm._v(" "),
                                _c("strong", [_vm._v("Загрузка")])
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "cell(index)",
                        fn: function(row) {
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(row.index + 1) +
                                "\n            "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(work_type_id)",
                        fn: function(row) {
                          return [
                            _c("b-form-select", {
                              attrs: {
                                id: "input_work_type",
                                size: "sm",
                                options: _vm.work_type_catalogs
                              },
                              model: {
                                value: row.item.work_type_id,
                                callback: function($$v) {
                                  _vm.$set(row.item, "work_type_id", $$v)
                                },
                                expression: "row.item.work_type_id"
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "cell(name)",
                        fn: function(row) {
                          return [
                            _c("b-form-input", {
                              attrs: {
                                id: "input_name",
                                size: "sm",
                                autocomplete: "off"
                              },
                              model: {
                                value: row.item.name,
                                callback: function($$v) {
                                  _vm.$set(row.item, "name", $$v)
                                },
                                expression: "row.item.name"
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "cell(price)",
                        fn: function(row) {
                          return [
                            _c("b-form-input", {
                              staticClass: "widthPrice",
                              attrs: {
                                id: "input_price",
                                size: "sm",
                                autocomplete: "off"
                              },
                              model: {
                                value: row.item.price,
                                callback: function($$v) {
                                  _vm.$set(row.item, "price", _vm._n($$v))
                                },
                                expression: "row.item.price"
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "cell(count)",
                        fn: function(row) {
                          return [
                            _c("b-form-input", {
                              staticClass: "widthPrice",
                              attrs: {
                                id: "input_count",
                                size: "sm",
                                autocomplete: "off"
                              },
                              model: {
                                value: row.item.count,
                                callback: function($$v) {
                                  _vm.$set(row.item, "count", _vm._n($$v))
                                },
                                expression: "row.item.count"
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "cell(nds)",
                        fn: function(row) {
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(row.item.nds) +
                                "%\n            "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(unit)",
                        fn: function(row) {
                          return [
                            _c("unit-select", {
                              ref: "unit_select",
                              attrs: {
                                id: "input_unit",
                                "initial-unit": row.item.unit_code,
                                "is-short": ""
                              },
                              on: {
                                selectUnit: function($event) {
                                  return _vm.updateUnit($event, row)
                                }
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "cell(summa)",
                        fn: function(row) {
                          return [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.priceFormat(row.item.summa)) +
                                "\n            "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(action)",
                        fn: function(row) {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "link" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeWork(row)
                                  }
                                }
                              },
                              [
                                _c("v-icon", {
                                  attrs: { name: "buttons/trash", size: 16 }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-pagination" },
                [
                  _c("pagination-footer", {
                    attrs: {
                      "total-rows": _vm.newItem.works.length,
                      "per-page": _vm.worksPerPage,
                      "current-page": _vm.worksCurrentPage
                    },
                    on: {
                      "update:currentPage": function($event) {
                        _vm.worksCurrentPage = $event
                      },
                      "update:current-page": function($event) {
                        _vm.worksCurrentPage = $event
                      },
                      "per-page-change": _vm.onPerPageChange
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "footer-list",
                        fn: function() {
                          return [
                            _vm._v("\n              Всего работ: "),
                            _c("b", [
                              _vm._v(_vm._s(this.newItem.works.length))
                            ]),
                            _vm._v(" |\n            ")
                          ]
                        },
                        proxy: true
                      }
                    ])
                  })
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27e0500e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27e0500e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Invoices/InvoiceAct.vue
// module id = null
// module chunks = 